import { render, staticRenderFns } from "./p-success.vue?vue&type=template&id=57df7253&scoped=true&"
import script from "./p-success.vue?vue&type=script&lang=js&"
export * from "./p-success.vue?vue&type=script&lang=js&"
import style0 from "./p-success.vue?vue&type=style&index=0&id=57df7253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df7253",
  null
  
)

export default component.exports